import React from 'react';
import { createRoot } from 'react-dom/client';
// Start hero slides prefetch immediately - before React renders
import './lib/hero-prefetch';
import App from './App.tsx';
import './index.css';
import './styles/invoice.css';

// Ensure React is available globally for all hooks and components
window.React = React;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
